import React from 'react';
import cc from 'classcat';

type IconButtonVatiant = 'contained' | 'outline' | 'icon';
type IconButtonShape = 'square' | 'circle';
type IconButtonType = 'button' | 'submit' | 'reset';

interface IIconButton {
    onClick: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
    iconUrl: string;
    iconAlt: string;
    variant?: IconButtonVatiant;
    shape?: IconButtonShape;
    disabled?: boolean;
    type?: IconButtonType;
}

export const IconButton = ({
    className,
    onClick,
    iconUrl,
    iconAlt,
    type,
    variant = 'contained',
    shape = 'square',
    disabled = false,
}: IIconButton) => {
    return (
        <button
            type={type ? type : 'submit'}
            onClick={onClick}
            className={cc(['icon-button', `icon-button--${variant}`, `icon-button--${shape}`, className])}
            disabled={disabled}
        >
            <img src={iconUrl} alt={iconAlt} />
        </button>
    );
};
